import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA](state, { aba, habilitar }) {
		state.abas[aba].isVisivel = habilitar
	},

	[mutationTypes.PENALIDADES.SET_ORGAO_SANCIONADOR_SALVO](state, orgaoSancionadorSalvo) {
		state.orgaoSancionadorSalvo = orgaoSancionadorSalvo
	},

	[mutationTypes.PENALIDADES.SET_FORNECEDOR_SALVO](state, fornecedorSalvo) {
		state.fornecedorSalvo = fornecedorSalvo
	},

	[mutationTypes.PENALIDADES.SET_ID_PENALIDADE_SALVA](state, idPenalidadeSalva) {
		state.idPenalidadeSalva = idPenalidadeSalva
	},

	[mutationTypes.PENALIDADES.SET_ABA_SELECIONADA](state, aba) {
		state.abaSelecionada = aba
	},

	[mutationTypes.PENALIDADES.SET_SALVAR_EFETIVAR_SANCAO](state, isEfetivar) {
		isEfetivar ? state.efetivarSancaoPenalidade++ : state.salvarSancaoPenalidade++
	},

	[mutationTypes.PENALIDADES.SET_IS_PENALIDADE_EFETIVADA](state) {
		state.isPenalidadeEfetivada = true
	},

	[mutationTypes.PENALIDADES.SET_SALVAR_ITENS](state) {
		state.salvarItensPenalidade++
	},

	[mutationTypes.PENALIDADES.SET_INSERIR_NOTIFICACAO](state) {
		state.inserirNotificacaoPenalidade++
	},

	[mutationTypes.PENALIDADES.RESET_INFORMACOES](state) {
		state.abas.map((aba) => {
			if (['Sancao', 'Notificacoes'].includes(aba.nome)) return
			aba.isVisivel = false
		})
		state.orgaoSancionadorSalvo = null
		state.fornecedorSalvo = null
		state.idPenalidadeSalva = null
		state.abaSelecionada = null
		state.salvarSancaoPenalidade = 0
		state.efetivarSancaoPenalidade = 0
		state.isPenalidadeEfetivada = false
		state.salvarItensPenalidade = 0
		state.inserirNotificacaoPenalidade = 0
	},
}
